<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>采购管理</el-breadcrumb-item>
                <el-breadcrumb-item>供应商管理</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <el-form label-width="90px" class="search-form">
            <el-row>
                <el-form-item label="关键词" prop="keyword">
                    <el-col>
                        <el-input v-model="query.keyword" prefix-icon="Search" placeholder="供应商编号/名称" @keyup.enter="fetchs()"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="供应商类型"  label-width="120px">
                    <el-select v-model="supplierType" clearable placeholder="请选择" @change="fetchs()"
                        style="min-width: 120px;">
                        <el-option key="原材料" label="原材料" value="原材料"></el-option>
                        <el-option key="成品" label="成品" value="成品"></el-option>
                        <el-option key="服务" label="服务" value="服务"></el-option>
                        <el-option key="其他" label="其他" value="其他"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="状态">
                    <el-select v-model="status" clearable placeholder="请选择" @change="fetchs()" style="min-width: 80px;">
                        <el-option key="1" label="启用" value="1"></el-option>
                        <el-option key="0" label="停用" value="0"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="" label-width="20px">
                    <el-button type="primary" icon="search" @click="fetchs()">搜索</el-button>
                </el-form-item>
            </el-row>
        </el-form>

        <div class="toolbar">
            <el-button type="primary" icon="Plus" @click="add()">新增</el-button>
            <el-button type="danger" icon="Delete" @click="deleter()">删除</el-button>

            <el-dropdown style="margin-left:20px;">
                <el-button plain type="primary">
                    <el-icon style="margin-right:5px;">
                        <Upload />
                    </el-icon>
                    数据操作
                </el-button>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item @click="download()">导出信息</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>

        <basic-table ref="table" class="table" :query="query" @handler="fetchs">
            <template v-slot:toolbar="scope">
                <el-button @click="edit(scope.row)" link size="small" type="primary" icon="Edit">[编辑]</el-button>
                <el-button @click="view(scope.row)" link size="small" type="info" icon="View">[查看]</el-button>
            </template>
            <template v-slot:status="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
                    {{ scope.row.status === 1 ? '启用' : '停用' }}
                </el-tag>
            </template>
        </basic-table>
    </el-card>
</template>

<script>
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";

export default {
    name: "PurchaseSupplier",
    components: { StaticDialog, BasicTable },
    data() {
        return {
            query: {
                keyword: "",
                columns: [
                    { type: "index", label: "序号" },
                    { prop: "supplierCode", label: "供应商编号", sortable: true, searchable: true, width: "140", showOverflowTooltip: true },
                    { prop: "supplierName", label: "供应商名称", sortable: true, searchable: true, width: "200", showOverflowTooltip: true },
                    { prop: "supplierType", label: "类型", sortable: true, searchable: true, width: "100" },
                    { prop: "contactName", label: "联系人", sortable: true, searchable: true, width: "100" },
                    { prop: "contactPhone", label: "联系电话", sortable: true, searchable: true, width: "120" },
                    { prop: "contactEmail", label: "联系邮箱", sortable: true, searchable: true, width: "150", showOverflowTooltip: true },
                    { prop: "contactAddress", label: "联系地址", searchable: true, width: "180", showOverflowTooltip: true },
                    { prop: "legalPerson", label: "法人代表", searchable: true, width: "100", showOverflowTooltip: true },
                    { prop: "taxNo", label: "税号", searchable: true, width: "120", showOverflowTooltip: true },
                    { prop: "bankName", label: "开户银行", searchable: true, width: "120", showOverflowTooltip: true },
                    { prop: "bankAccount", label: "银行账号", searchable: true, width: "120", showOverflowTooltip: true },
                    { prop: "creditLevel", label: "信用等级", sortable: true, width: "90" },
                    { prop: "paymentTerm", label: "付款条件", width: "120", showOverflowTooltip: true },
                    { prop: "status", label: "状态", type: "template", sortable: true, width: "80" },
                    { prop: "createDate", label: "创建时间",sortable: true, width: "140" },
                    { prop: "createUserName", label: "创建人", searchable: true, width: "90", showOverflowTooltip: true },
                    { prop: "updateDate", label: "更新时间",sortable: true, width: "150" },
                    { prop: "updateUserName", label: "更新人", searchable: true, width: "90", showOverflowTooltip: true },
                    { prop: "remark", label: "备注", searchable: true, width: "150", showOverflowTooltip: true },
                    { type: "toolbar", label: "操作", width: "140" }
                ],
                filters: []
            },
            supplierType: '',
            status: '',
        };
    },
    mounted() {
        //kaung插件初始化
        this.$kaung.init(this.$options.name);
        this.fetchs();
    },
    methods: {
        edit(row) {
            this.$router.push({ name: 'PurchaseSupplierDetail', query: { id: row.id } });
        },
        add() {
            this.$router.push({ name: 'PurchaseSupplierDetail' });
        },
        view(row) {
            this.$router.push({ name: 'PurchaseSupplierDetail', query: { id: row.id, mode: 'view' } });
        },

        builder() {
            let { data, records, total, ...params } = { ...this.query };

            // 重置并添加筛选条件
            params.filters = [];
            if (this.supplierType) {
                params.filters.push({ name: "supplierType", value: this.supplierType, operate: 0 });
            }
            if (this.status) {
                params.filters.push({ name: "status", value: this.status, operate: 0 });
            }
            return params;
        },
        fetchs() {
            let params = this.builder();
            this.$kaung.search(params).then((res) => {
                this.query = { ...res.data };
            });
        },

        download() {
            let params = this.builder();
            this.$kaung.export(params).then((res) => {
                this.$notify({
                    title: '表格数据导出',
                    message: res.content,
                    type: res.type,
                    duration: 10000
                });
                window.location.href = process.env.VUE_APP_BASEURL + res.data;
            });
        },

        deleter() {
            if (!this.$refs.table.chooseRow) {
                this.$message({ message: '请点击选择要删除的数据行', type: 'warning' });
                return;
            }

            let that = this;
            this.$confirm("此操作将删除本页选择数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$kaung.delete(that.$refs.table.chooseRow.id).then((res) => {
                        if (res.code === 200) {
                            that.$message({ message: res.content, type: res.type });
                            that.fetchs();
                        }
                    });
                });
        },

    }
};
</script>
